// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dc-logo[data-v-405aa8ba] {\n\twidth: 35px;\n\tmax-height: 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
